<ion-accordion-group>
    <ion-accordion
        class="vl-app-light-dark:rounded-none vl-app-light-dark:border-b rounded-md border-0 border-solid border-b-[var(--color-panel-border)]"
        *ngFor="let message of viewMessages$ | async; let last = last"
        [class.mb-2]="!last"
        (click)="onAccordionClick()">
        <ion-item class="text-base" slot="header">
            <ion-grid class="w-full max-w-full overflow-hidden py-2">
                <ion-row class="relative w-full max-w-full items-center justify-between overflow-hidden">
                    <ion-row
                        class="w-full max-w-full flex-wrap items-center overflow-hidden"
                        [class.mr-6]="env.DISRUPTION_MESSAGES?.SHOW_ROUTES_WITH_STOPS">
                        <ng-container *ngIf="message.isGeneric && !message.effectType">
                            <ion-col class="self-center" size="auto">
                                <ion-icon class="text-2xl" name="warning-outline" color="danger"></ion-icon>
                            </ion-col>
                            <ion-col class="self-center" size="auto">
                                <ion-label class="text-base font-bold leading-5">{{
                                    'DISRUPTION_TYPE_GENERIC' | translate
                                }}</ion-label>
                            </ion-col>
                        </ng-container>
                        <ng-container *ngIf="message.isGeneric && !!message.effectType">
                            <ion-col class="self-center" size="auto">
                                <ion-label class="text-base font-bold leading-5">{{
                                    message.effectType | translate
                                }}</ion-label>
                            </ion-col>
                        </ng-container>
                        <ng-container *ngIf="message.isBus && !message.isBusAndStop && !message.effectType">
                            <ion-col class="self-center" size="auto">
                                <ion-label class="text-base font-bold leading-5">{{
                                    'DISRUPTION_TYPE_LINES' | translate
                                }}</ion-label>
                            </ion-col>
                            <ion-col class="self-center" *ngFor="let line of message.lines" size="auto">
                                <rwidget-route-short-name
                                    *ngIf="line?.icon && line?.line && line.line !== ''"
                                    [label]="line.line"
                                    [color]="line.icon?.color"
                                    [shape]="line.icon?.shape || ShapeType.ROUNDED"
                                    size="md"></rwidget-route-short-name>
                                <div
                                    class="flex h-7 w-7 items-center justify-center overflow-hidden rounded-full bg-secondary text-xs font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                                    *ngIf="!line?.icon && line?.line">
                                    {{ line?.line }}
                                </div>
                            </ion-col>
                        </ng-container>
                        <ng-container *ngIf="message.isBusAndStop && !message.effectType">
                            <ion-col class="flex-shrink-0 self-center" size="auto">
                                <ion-label class="whitespace-nowrap text-base font-bold leading-5">{{
                                    'DISRUPTION_TYPE_LINES' | translate
                                }}</ion-label>
                            </ion-col>
                            <ion-col class="flex-shrink-0 self-center" *ngFor="let line of message.lines" size="auto">
                                <rwidget-route-short-name
                                    *ngIf="line?.icon && line?.line && line.line !== ''"
                                    [label]="line.line"
                                    [color]="line.icon?.color"
                                    [shape]="line.icon?.shape || ShapeType.ROUNDED"
                                    size="md"></rwidget-route-short-name>
                                <div
                                    class="flex h-7 w-7 flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-secondary text-xs font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                                    *ngIf="!line?.icon && line?.line">
                                    {{ line?.line }}
                                </div>
                            </ion-col>
                            <ng-container *ngIf="message.stops as stops">
                                <ion-col class="self-center p-1" *ngIf="stops.length > 0" size="12">
                                    <ion-label
                                        class="block whitespace-normal break-words text-base font-bold leading-5">
                                        {{ 'STOPS' | translate }}: {{ stops.join(', ') }}
                                    </ion-label>
                                </ion-col>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="message.isStop && !message.isBusAndStop && !message.effectType">
                            <ng-container *ngIf="message.stops as stops">
                                <ion-col class="self-center" *ngIf="stops.length > 0" size="auto">
                                    <ion-label class="!whitespace-normal text-base font-bold leading-5">
                                        {{ 'STOPS' | translate }}: {{ stops.join(', ') }}
                                    </ion-label>
                                </ion-col>
                            </ng-container>
                        </ng-container>
                    </ion-row>
                    <ion-icon
                        class="accordion-icon hu-light-dark:text-secondary gl-light:text-black text-2xl text-primary dark:filter-yellow"
                        name="chevron-down"></ion-icon>
                </ion-row>
                <ion-row
                    *ngIf="env.DISRUPTION_MESSAGES?.SHOW_ROUTES_WITH_STOPS && message.isStop && !message.effectType">
                    <ion-col class="self-center" size="auto">
                        <ion-label class="text-base font-bold leading-5">{{ 'LINES' | translate }}</ion-label>
                    </ion-col>
                    <ion-col class="self-center" *ngFor="let line of message.lines" size="auto">
                        <rwidget-route-short-name
                            *ngIf="line?.icon"
                            [label]="line.line"
                            [color]="line.icon?.color"
                            [shape]="line.icon?.shape || ShapeType.ROUNDED"
                            size="md"></rwidget-route-short-name>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col class="vl-app-light:text-sm text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                        <ng-container *ngIf="dateRangeFormatOptions">
                            {{ message.activePeriod | dateTimeRange: dateRangeFormatOptions }}
                        </ng-container>
                        <ng-container *ngIf="!dateRangeFormatOptions">
                            {{ message.activePeriodStart | momentDate: env.PRIMARY_DATE_TIME_FORMAT : env.TIMEZONE }} -
                            {{ message.activePeriodEnd | momentDate: env.PRIMARY_DATE_TIME_FORMAT : env.TIMEZONE }}
                        </ng-container>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        {{ message.header }}
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>
        <div class="text-2xl" slot="end"></div>
        <div slot="content">
            <section class="border-t border-solid p-3 dark:border-contrast-yellow dark:bg-contrast-black">
                {{ message.description }}

                <a
                    class="mt-4 flex h-14 items-center justify-center gap-2 text-[16px] font-semibold leading-5 text-secondary hover:no-underline"
                    *ngIf="message?.urlDefault"
                    [href]="message?.urlDefault"
                    [attr.target]="_blank"
                    [attr.aria-label]="'READ_MORE' | translate">
                    {{ 'READ_MORE' | translate }}
                    <ion-icon
                        class="dark:filter-yellow"
                        src="{{ assetsPath$ | async }}/img/disruptions/arrow-right.svg"></ion-icon>
                </a>
                <div *ngFor="let url of message.processedAlertUrls">
                    <ng-container [ngSwitch]="url.type">
                        <img
                            *ngSwitchCase="'image'"
                            (click)="openImageFullScreen(url)"
                            src="{{ url.src }}"
                            alt="{{ url.alt }}" />
                        <a
                            class="flex h-14 items-center justify-center gap-2 text-sm font-semibold leading-5 text-secondary hover:no-underline"
                            *ngSwitchCase="'url'"
                            [href]="url.src"
                            [attr.aria-label]="'READ_MORE' | translate"
                            target="_blank">
                            {{ 'READ_MORE' | translate }}
                            <ion-icon
                                class="dark:filter-yellow"
                                name="arrow-forward-outline"
                                aria-hidden="true"></ion-icon>
                        </a>
                    </ng-container>
                </div>
            </section>
        </div>
    </ion-accordion>
</ion-accordion-group>

<ion-modal
    class="disruption-message-image_modal"
    [isOpen]="!!selectedImageConfig"
    (didDismiss)="closeSelectedImageModal()">
    <ng-template>
        <ion-slides [options]="{ zoom: true, allowSlideNext: false, allowSlidePrev: false }" pager="true">
            <ion-slide>
                <div class="swiper-zoom-container">
                    <!--                    selectedImageConfig is used with '?' operator because ion-modal works through isOpen, and doesn't work with ngIf*/@for-->
                    <img [src]="selectedImageConfig?.src" [alt]="selectedImageConfig?.alt" />
                </div>
            </ion-slide>
        </ion-slides>
    </ng-template>
</ion-modal>
